import React from "react";
import "./Hero.css";
import { FaStethoscope, FaFileMedical, FaVials, FaHandsHelping } from "react-icons/fa";

const Hero = () => {
    return (
        <section id="hero" className="hero">
            <div className="hero-overlay">

                <div className="hero-container">

                    <div className="hero-text">
                        <h1>Добредојдовте во Лукс Медикус</h1>
                        <p>Нашата мобилност е ваша предност</p>
                    </div>

                    <div className="hero-cards">

                        <div className="why-card">
                            <h2>Закажете термин брзо и едноставно, без чекање.</h2>
                            <p>
                                Изберете термин што ви одговара и добијте брза и професионална услуга.     </p>

                            <button
                                className="learn-btn"
                                onClick={() =>
                                    document.getElementById("appointment").scrollIntoView({
                                        behavior: "smooth"
                                    })
                                }
                            >
                                Закажи термин
                            </button>
                        </div>

                        <div className="info-card">
                            <FaStethoscope className="icon" />
                            <h3>Систематски прегледи</h3>

                        </div>

                       
                        <div className="info-card highlight-card">
                            <div className="promo-badge">
                                АКЦИЈА
                                <br />

                                {/* <span className="old-price">1600</span> */}
                                <span className="new-price-hero">800 ден</span>
                            </div>

                            <FaFileMedical className="icon" />
                            <h3>Лекарски уверенија</h3>
                        </div>
                        <div className="info-card">
                            <FaVials className="icon" />
                            <h3>Лабораторија</h3>
                        </div>

                       <div className="info-card">
                            <FaHandsHelping  className="icon" />
                            <h3>Обуки</h3>
                            {/* <p>Обука за прва помош на работно место</p>
                            <p>Практична обука за психосоцијални ризици и превенција од burnout</p> */}
                        </div>


                    </div>

                </div>

            </div>
        </section>
    );
};

export default Hero;